export default __webpack_public_path__ + "correct-symbol.png";